import { render, staticRenderFns } from "./VariantSifterMappingRowDetails.vue?vue&type=template&id=484566e4&scoped=true&"
import script from "./VariantSifterMappingRowDetails.vue?vue&type=script&lang=js&"
export * from "./VariantSifterMappingRowDetails.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterMappingRowDetails.vue?vue&type=style&index=0&id=484566e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484566e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484566e4')) {
      api.createRecord('484566e4', component.options)
    } else {
      api.reload('484566e4', component.options)
    }
    module.hot.accept("./VariantSifterMappingRowDetails.vue?vue&type=template&id=484566e4&scoped=true&", function () {
      api.rerender('484566e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterMappingRowDetails.vue"
export default component.exports